import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TranslatePipe } from '@ngx-translate/core';

import { CalloutComponent } from './callout.component';

@Component({
  selector: 'guarantees-self-pay-disclaimer',
  standalone: true,
  imports: [TranslatePipe, CalloutComponent],
  host: { class: 'block' },
  template: ` <guarantees-callout tone="info" icon="payments">{{ 'guaranteeV2.message.selfPayDisclaimer' | translate }}</guarantees-callout> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelfPayDisclaimerComponent {}
